export default __webpack_public_path__ + "static/global_brigades-c7436de2aff3b4d1f619650bfd5bfb84.webp";